<template>
  <f7-page data-tour-id="samples-register-page-root">
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded" class="card margin">
      <div
        class="header-container"
        data-tour-id="samples-register-header"
      >
        <span class="header-title">
          {{ $t('NewSample') }}
        </span>

        <div v-if="selectedIndex === 0" class="header-side-actions">
          <button
            v-if="expressMode"
            type="button"
            class="header-template-button"
            :aria-label="$t('bubbleToggle.openTemplates')"
            :title="$t('bubbleToggle.openTemplates')"
            @click="openTemplatesFromHeader"
          >
            <svg
              class="header-template-button__icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M7 2.5h6.8L19.5 8v11.2A2.3 2.3 0 0 1 17.2 21.5H7
                a2.3 2.3 0 0 1-2.3-2.3V4.8A2.3 2.3 0 0 1 7 2.5Zm6.1 1.8v3.2
                c0 .6.4 1 1 1h3.2l-4.2-4.2ZM8.2 11h7.6v1.4H8.2V11Zm0 3.2h7.6v1.4H8.2v-1.4Zm0-6.4h3.2v1.4H8.2V7.8Z"
              />
            </svg>
            <span>{{ $t('manageTemplates') }}</span>
          </button>
          <div>
            <a
              id="register-info"
              class="register-info"
              @mouseenter="toggleWithAnimationOptions"
              @mouseleave="toggleWithAnimationOptions"
            >
              <i class="f7-icons f7-icon-custom">info_circle_fill</i>
            </a>
          </div>
        </div>

        <f7-button
          v-if="selectedIndex === 1"
          class="whiteFontColor button-primary-outlined header-action"
          data-tour-id="samples-register-add-another-sample-button"
          fill
          outline
          type="default"
          styling-mode="contained"
          name="guardado"
          @click="addSample"
        >
          {{ $t('Add_samples_to_the_delivery_note') }}
        </f7-button>
      </div>
      <DxPopover
        width="auto"
        height="auto"
        class="register-popover"
        :visible="withAnimationOptionsVisible"
        :animation="animationConfig"
        target="#register-info"
        position="left"
      >
        <div style="padding: 1px 15px">
          <p>{{ $t('need_help') }}</p>
          <ul>
            <li>
              {{ $t('samplesRegister.lmrEnabled') }}:
              {{ $t('samplesRegister.tooltip.lmr') }}
            </li>
            <li>
              {{ $t('samplesRegister.cmaEnabled') }}:
              {{ $t('samplesRegister.tooltip.cma') }}
            </li>
            <li>
              {{ $t('samplesRegister.trace') }}:
              {{ $t('samplesRegister.tooltip.trace') }}
            </li>
            <li>
              {{ $t('samplesRegister.organicFarming') }}:
              {{ $t('samplesRegister.tooltip.organicFarming') }}
            </li>
            <li>
              {{ $t('samplesRegister.automaticSamplingPoint') }}:
              {{
                $t('samplesRegister.tooltip.automaticSamplingPoint')
              }}
            </li>
          </ul>
        </div>
      </DxPopover>

      <DxTabPanel
        ref="tabPanelRef"
        data-tour-id="samples-register-tab-panel"
        :selected-index="selectedIndex"
        :data-source="tabsConfig"
        :loop="false"
        :animation-enabled="true"
        :swipe-enabled="false"
        @selection-changed="onTabChange"
      >
        <template #title="{ data }">
          <span class="tab-title">
            <span
              class="fa-stack fa-sm"
              style="vertical-align: middle"
            >
              <i class="fas fa-stack-2x"></i>
              <strong> {{ data.selectedIndex }}. </strong>
            </span>
            <span style="margin-left: -6px">
              {{ data.text }}
            </span>
          </span>
        </template>
        <template #item="{ data }">
          <div>
            <div v-if="data.selectedIndex === 1">
              <div data-tour-id="samples-register-standard-panel">
                <SampleRegister
                  v-show="!expressMode"
                  ref="standardSampleRegister"
                  :store="CustomStore"
                />
              </div>
              <ExpressSampleRegister
                v-if="expressMode"
                ref="expressSampleRegister"
                :store="CustomStore"
                :invoice-samples="invoiceSamples"
                @save-samples="SaveSample"
                @request-save-template="onSimpleSaveTemplateRequest"
              />
              <div
                class="content-setting display-flex justify-content-space-between margin gap samples-register-footer-actions"
              >
                <div class="samples-register-actions-left">
                  <f7-button
                    class="goBack samples-register-cancel-button"
                    outline
                    type="default"
                    styling-mode="contained"
                    name="cancel"
                    @click="goBack"
                  >
                    {{ $t('cancelAndReturnToList') }}
                  </f7-button>
                </div>

                <div class="samples-register-actions-right">
                  <f7-button
                    v-if="!expressMode"
                    class="botones-registrar color-green whiteFontColor button-primary"
                    data-tour-id="samples-register-standard-save-button"
                    fill
                    outline
                    type="default"
                    styling-mode="contained"
                    name="guardado"
                    @click="SaveSample"
                  >
                    {{ $t('SaveSample') }}
                  </f7-button>

                  <f7-button
                    v-if="shouldShowContinueButton"
                    class="whiteFontColor button-primary-outlined samples-register-review-button"
                    data-tour-id="samples-register-go-confirmation-button"
                    fill
                    outline
                    type="default"
                    name="GoConfirmar"
                    styling-mode="contained"
                    @click="GoConfirmar"
                  >
                    {{ $t('samplesRegister.checkTheOrder') }}
                  </f7-button>
                </div>
              </div>
            </div>
            <div
              v-if="data.selectedIndex === 2"
              data-tour-id="samples-register-confirmation-tab"
            >
              <div class="no-margin sampleTable">
                <SamplesConfirmationTable :store="invoiceSamples" />
              </div>
            </div>
            <div
              v-if="data.selectedIndex === 3"
              class="no-margin"
              data-tour-id="samples-register-shipping-tab"
            >
              <div class="formulario">
                <SamplesConfirmation
                  :store="agencies"
                  @confirm-invoice="ConfirmInvoice"
                />
              </div>
            </div>
          </div>
        </template>
      </DxTabPanel>
      <SampleRegisterConfirmPopUp />
      <ExpressSampleRegisterConfirmPopUp />
      <SamplingTemplatesAvailablePopUp />
      <InvoiceConfirmatedPopUp />
      <SampleRegisterErrorPopUp />
      <DxPopup
        :visible="showUnsavedSampleWarningPopup"
        :close-on-outside-click="true"
        :show-close-button="true"
        class="DxPopup popUp-custom"
        :wrapper-attr="{
          class:
            'albaran-popup samples-register-unsaved-warning-popup',
        }"
        width="730"
        height="auto"
        :title-template="'unsavedWarningTitle'"
        container=".dx-viewport"
        @hiding="hideUnsavedSampleWarningPopup"
      >
        <template #unsavedWarningTitle>
          <div class="custom-popup-title">
            <div class="warning-popup-icon"></div>
          </div>
        </template>
        <div class="popup-content">
          <h2 class="popup-title">
            {{ $t('samplesRegister.unsavedSampleWarningMessage') }}
          </h2>
          <div class="popup-actions">
            <f7-button
              class="btn-secondary margin-right"
              type="default"
              @click="saveSampleFromWarningPopup"
            >
              {{ $t('SaveSample') }}
            </f7-button>
            <f7-button
              class="btn-accept"
              fill
              outline
              type="default"
              @click="continueWithoutSavingSample"
            >
              {{ $t('samplesRegister.continueWithoutSaving') }}
            </f7-button>
          </div>
        </div>
      </DxPopup>
      <DxPopup
        :visible="showModeSwitchWarningPopup"
        :close-on-outside-click="true"
        :show-close-button="true"
        class="DxPopup popUp-custom"
        :wrapper-attr="{
          class:
            'albaran-popup samples-register-unsaved-warning-popup',
        }"
        width="730"
        height="auto"
        :title-template="'modeSwitchWarningTitle'"
        container=".dx-viewport"
        @hiding="cancelExpressModeSwitch"
      >
        <template #modeSwitchWarningTitle>
          <div class="custom-popup-title">
            <div class="warning-popup-icon"></div>
          </div>
        </template>
        <div class="popup-content">
          <h2 class="popup-title">
            {{
              $t('samplesRegister.unsavedModeSwitchWarningMessage')
            }}
          </h2>
          <div class="popup-actions">
            <f7-button
              class="btn-secondary margin-right"
              type="default"
              @click="cancelExpressModeSwitch"
            >
              {{ $t('samplesRegister.modeSwitchBack') }}
            </f7-button>
            <f7-button
              class="btn-accept"
              fill
              outline
              type="default"
              @click="confirmExpressModeSwitch"
            >
              {{ $t('samplesRegister.modeSwitchContinue') }}
            </f7-button>
          </div>
        </div>
      </DxPopup>
    </div>
    <BubbleToggle
      :value="expressMode"
      storage-key="samplesRegisterExpressMode"
      :show-templates-button="false"
      @toggle="onExpressModeToggle"
      @edit-click="onEditBubbleClick"
    />
    <SelectablesFieldsPopup
      v-model="showSelectablesFieldsPopup"
      :fields-visibility="expressGridFieldsVisibility"
      @apply="onApplyExpressFieldsVisibility"
    />
  </f7-page>
</template>

<script>
import { DxTabPanel } from 'devextreme-vue/tab-panel';
import { DxPopover } from 'devextreme-vue/popover';
import { DxPopup } from 'devextreme-vue/popup';
import { mapActions, mapState } from 'vuex';
import SampleRegister from '@/components/SamplesRegister/SampleRegister.vue';
import ExpressSampleRegister from '@/components/SamplesRegister/ExpressSampleRegister/ExpressSampleRegister.vue';
import {
  NOTIFY_TIME_LONG,
  SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY,
} from '@/js/constants';
import SampleRegisterConfirmPopUp from '@/components/SamplesRegister/SampleRegisterConfirmPopUp/SampleRegisterConfirmPopUp.vue';
import ExpressSampleRegisterConfirmPopUp from '@/components/SamplesRegister/ExpressSampleRegister/ExpressSampleRegisterConfirmPopUp/ExpressSampleRegisterConfirmPopUp.vue';
import SamplingTemplatesAvailablePopUp from '@/components/SamplesRegister/SamplingTemplatesAvailablePopUp/SamplingTemplatesAvailablePopUp.vue';
import InvoiceConfirmatedPopUp from '@/components/SamplesRegister/InvoiceConfirmatedPopUp/InvoiceConfirmatedPopUp.vue';
import SamplesConfirmation from '@/components/SamplesRegister/SamplesConfirmation/SamplesConfirmation.vue';
import SamplesConfirmationTable from '@/components/SamplesRegister/SamplesConfirmation/SamplesConfirmationTable.vue';
import EventBus from '@/services/event-bus';
import SampleRegisterErrorPopUp from '@/components/SamplesRegister/SampleRegisterErrorPopUp/SampleRegisterErrorPopUp.vue';
import BubbleToggle from '@/components/UtilityComponents/ExpressRegisterBubbleToggleBottom/BubbleToggle.vue';
import SelectablesFieldsPopup from '@/components/UtilityComponents/SelectablesFieldsPopUp/SelectablesFieldsPopup.vue';
import {
  consumePendingSamplesRegisterTourStart,
  consumePendingSamplesRegisterTemplateResumeTourStart,
  isSamplesRegisterGuidedTourActiveOrPending,
  startSamplesRegisterGuidedTour,
  startSamplesRegisterTemplateResumeGuidedTour,
  stopSamplesRegisterGuidedTour,
} from '@/services/samplesRegisterGuidedTour';
import { emitSamplesRegisterGa4Event } from '@/services/samplesRegisterAnalytics';

const SAMPLING_TEMPLATES_POPUP_SESSION_KEY =
  'samplesRegister_samplingTemplatesAvailablePopup_shown';
const SAMPLING_TEMPLATES_POPUP_MAX_PER_SESSION = 1;

export default {
  components: {
    SampleRegister,
    SampleRegisterConfirmPopUp,
    ExpressSampleRegisterConfirmPopUp,
    SamplingTemplatesAvailablePopUp,
    ExpressSampleRegister,
    DxTabPanel,
    DxPopover,
    DxPopup,
    SamplesConfirmation,
    SamplesConfirmationTable,
    InvoiceConfirmatedPopUp,
    SampleRegisterErrorPopUp,
    BubbleToggle,
    SelectablesFieldsPopup,
  },
  data() {
    return {
      loaded: false,
      CustomStore: [],
      selectedIndex: 0,
      lastRegisteredMode: null,
      lastFormData: null,
      lastFormData2: null,
      showContinueBottom: false,
      withAnimationOptionsVisible: false,
      showUnsavedSampleWarningPopup: false,
      pendingUnsavedAction: null,
      suppressNextTabGuard: false,
      showModeSwitchWarningPopup: false,
      expressMode: false, // estado ON/OFF
      pendingExpressMode: null,
      showSelectablesFieldsPopup: false,
      expressGridFieldsVisibilityStorageKey:
        'samplesRegisterExpressGridFieldsVisibility',
      lastExpressAccessTrackedAt: 0,
      guidedTourStartTimeoutId: null,
      expressGridFieldsVisibility: {
        lote: false,
        SubTipoMuestra: false,
        cloroResidual: false,
        cma: false,
        Legislacion: false,
        automaticSamplingPoint: false,
        farmPoint: false,
        plotPoint: false,
        samplingPointCoordinate: false,
        lmr: false,
        trazaCultivo: false,
        CultivoOrganico: false,
        Observaciones: false,
        inSituPh: false,
        inSituTemperatura: false,
        inSituConductividadElectrica: false,
        inSituOxigenoDisuelto: false,
        inSituCloroLibre: false,
        inSituTurbidez: false,
        inSituMonocloraminas: false,
        inSituSalinidad: false,
        inSituMaterialFlotante: false,
        inSituTph: false,
        inSituPotencialRedox: false,
      },
      animationConfig: {
        show: {
          type: 'pop',
          from: {
            scale: 0,
          },
          to: {
            scale: 1,
          },
        },
        hide: {
          type: 'fade',
          from: 1,
          to: 0,
        },
      },
    };
  },
  computed: {
    shouldShowContinueButton() {
      return (
        this.showContinueBottom ||
        (Array.isArray(this.invoiceSamples) &&
          this.invoiceSamples.length > 0)
      );
    },
    tabsConfig() {
      const tabsConfig = [
        {
          id: 0,
          text: this.$t('sampleRegistration'),
          selectedIndex: 1,
        },
      ];

      tabsConfig.push({
        id: 1,
        text: this.$t('confirmation'),
        selectedIndex: 2,
        disabled: false,
      });
      tabsConfig.push({
        id: 2,
        text: this.$t('shipping'),
        selectedIndex: 3,
        disabled: false,
      });
      return tabsConfig;
    },
    ...mapState('Offers', ['presupuestos']),
    ...mapState('samplesRegisterModule', [
      'agencies',
      'invoiceSamples',
      'registeredInvoice',
      'idInvoice',
      'invoiceCodeInfoPopUp',
      'offerSelected',
    ]),
  },
  watch: {
    loaded(value) {
      if (value) {
        this.scheduleSamplesGuidedTourStart();
      }
    },
    '$f7route.query.tab': function () {
      this.applyRequestedTabFromRoute();
    },
    '$f7route.query.mode': function () {
      this.applyRequestedExpressModeFromRoute();
    },
  },
  beforeMount() {
    this.selectedIndex = this.resolveInitialTabIndex();
    this.expressMode = this.resolveInitialExpressMode();
    this.setCurrentRoute([
      {
        name: this.$t('SamplesList.orderList'),
        disabled: true,
        page: 'SamplesList',
        active: false,
      },
      {
        name: this.$t('SamplesRegister'),
        disabled: false,
        page: 'SamplesRegister',
        active: true,
      },
    ]);
  },
  async mounted() {
    this.loadExpressGridFieldsVisibility();
    this.applyRequestedExpressModeFromRoute();
    this.applyRequestedTabFromRoute();
    try {
      // this.$f7.preloader.show();
      await this.fetchPresupuestos({
        isOnlineRegister: true,
      });
      await this.fetchAgencies();
      await this.formatOffers();
      if (this.CustomStore.length === 0) {
        throw new Error('NO_offers');
      }
    } catch (error) {
      if (error.message === 'NO_offers') {
        this.$notifyDX(
          {
            message: this.$t('samplesRegister.noAvailableQuotes'),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } else {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    } finally {
      this.loaded = true;
      await this.$nextTick();
      this.bindTabNavigationGuard();
      await this.openSamplingTemplatesAvailablePopupIfNeeded();
      this.scheduleSamplesGuidedTourStart();
      // this.$f7.preloader.hide();
    }
  },
  created() {
    EventBus.$on('formData', this.receiveMessage);
    EventBus.$on('formData3', this.receiveMessageV2);
    EventBus.$on('addSample', this.ForwardTo);
    EventBus.$on('confirmOrder', this.ForwardTo);
    EventBus.$on('changeTab', this.ForwardTo);
    EventBus.$on('showBottom', this.showContinue);
    EventBus.$on('ExpressFormData', this.receiveMessage);
  },
  async beforeDestroy() {
    this.unbindTabNavigationGuard();
    this.clearSamplesGuidedTourStartTimeout();
    stopSamplesRegisterGuidedTour(this);
    EventBus.$off('formData', this.receiveMessage);
    EventBus.$off('formData3', this.receiveMessageV2);
    EventBus.$off('addSample', this.ForwardTo);
    EventBus.$off('confirmOrder', this.ForwardTo);
    EventBus.$off('changeTab', this.ForwardTo);
    EventBus.$off('ExpressFormData', this.receiveMessage);
  },
  methods: {
    bindTabNavigationGuard() {
      const tabPanelElement = this.$refs.tabPanelRef?.$el;
      if (!tabPanelElement || tabPanelElement.__expressGuardBound) {
        return;
      }

      tabPanelElement.addEventListener(
        'pointerdown',
        this.onTabPointerDownCapture,
        true
      );
      tabPanelElement.addEventListener(
        'click',
        this.onTabPointerDownCapture,
        true
      );
      tabPanelElement.__expressGuardBound = true;
    },
    unbindTabNavigationGuard() {
      const tabPanelElement = this.$refs.tabPanelRef?.$el;
      if (!tabPanelElement?.__expressGuardBound) {
        return;
      }

      tabPanelElement.removeEventListener(
        'pointerdown',
        this.onTabPointerDownCapture,
        true
      );
      tabPanelElement.removeEventListener(
        'click',
        this.onTabPointerDownCapture,
        true
      );
      delete tabPanelElement.__expressGuardBound;
    },
    async onTabPointerDownCapture(event) {
      if (!this.expressMode || this.selectedIndex !== 0) return;

      const targetTab = event?.target?.closest?.('.dx-tab');
      if (!targetTab) return;

      const tabs = Array.from(
        this.$refs.tabPanelRef?.$el?.querySelectorAll?.('.dx-tab') ||
          []
      );
      const clickedIndex = tabs.indexOf(targetTab);
      if (clickedIndex !== 1) return;

      await this.$refs.expressSampleRegister?.commitGridEdits?.();
      this.$refs.expressSampleRegister?.emitMultiForm?.();

      if (!this.shouldWarnBeforeContinue()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      this.pendingUnsavedAction = 'confirm';
      this.showUnsavedSampleWarningPopup = true;
    },
    clearSamplesGuidedTourStartTimeout() {
      if (this.guidedTourStartTimeoutId) {
        clearTimeout(this.guidedTourStartTimeoutId);
        this.guidedTourStartTimeoutId = null;
      }
    },
    scheduleSamplesGuidedTourStart({ force = false } = {}) {
      if (!this.loaded) return;
      const shouldResumeFromTemplateFlow =
        force ||
        consumePendingSamplesRegisterTemplateResumeTourStart();
      if (shouldResumeFromTemplateFlow) {
        this.setConfirmTemplatesAvailablePopup(false);
        this.clearSamplesGuidedTourStartTimeout();
        this.guidedTourStartTimeoutId = setTimeout(() => {
          this.guidedTourStartTimeoutId = null;
          startSamplesRegisterTemplateResumeGuidedTour(this, {
            force: true,
          });
        }, SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY);
        return;
      }

      const shouldContinueFromDashboard =
        force || consumePendingSamplesRegisterTourStart();
      if (!shouldContinueFromDashboard) {
        return;
      }

      this.setConfirmTemplatesAvailablePopup(false);
      this.clearSamplesGuidedTourStartTimeout();
      this.guidedTourStartTimeoutId = setTimeout(() => {
        this.guidedTourStartTimeoutId = null;
        startSamplesRegisterGuidedTour(this, { force: true });
      }, SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY);
    },
    async setTourTab(index) {
      this.$refs.tabPanelRef?.instance?.option(
        'selectedIndex',
        index
      );
      this.selectedIndex = index;
      await this.$nextTick();
    },
    async prepareSamplesRegisterTourStart() {
      await this.setTourTab(0);
      this.disableExpressModeForTour();
      this.closeTourVisibleFieldsPopup();
      this.hideTourStandardSavePopup();
      this.hideTourFinalConfirmationPopup();
      this.showContinueBottom = true;
      await this.$nextTick();
    },
    async prepareSamplesRegisterTemplateTourResume() {
      await this.setTourTab(0);
      this.enableExpressModeForTour();
      this.closeTourVisibleFieldsPopup();
      this.hideTourStandardSavePopup();
      this.hideTourFinalConfirmationPopup();
      this.setConfirmTemplatesAvailablePopup(false);
      this.showContinueBottom = true;
      await this.$nextTick();
      this.$refs.expressSampleRegister?.ensureOneRow?.();
      await this.$nextTick();
    },
    async prepareTourTemplateFlow() {
      this.enableExpressModeForTour();
      this.closeTourVisibleFieldsPopup();
      this.hideTourStandardSavePopup();
      this.hideTourFinalConfirmationPopup();
      this.setConfirmTemplatesAvailablePopup(false);
      this.showContinueBottom = true;
      await this.$nextTick();
      this.$refs.expressSampleRegister?.ensureOneRow?.();
      this.$refs.expressSampleRegister?.setTourSaveTemplateButtonDisabled?.(
        false
      );
      await this.$nextTick();
    },
    async openTourTemplateCreatePage() {
      try {
        await this.prepareTourTemplateFlow();
        this.$refs.expressSampleRegister?.setTourSaveTemplateButtonDisabled?.(
          true
        );
        await this.$nextTick();
        return (
          (await this.$refs.expressSampleRegister?.goToTemplateCreatePage?.(
            {
              forceForTour: true,
            }
          )) === true
        );
      } catch (error) {
        return false;
      } finally {
        this.$refs.expressSampleRegister?.applySaveTemplateDisabledState?.();
      }
    },
    setExpressModeStateForTour(isActive) {
      const toggleButton = document.querySelector(
        '[data-tour-id="samples-register-express-toggle-button"]'
      );
      const isToggleActive = Boolean(
        toggleButton?.classList.contains('is-active')
      );

      if (toggleButton && isToggleActive !== isActive) {
        toggleButton.click();
        return;
      }

      this.expressMode = isActive;
      EventBus.$emit('samplesRegister:expressMode', isActive);
      try {
        localStorage.setItem(
          'samplesRegisterExpressMode',
          JSON.stringify(isActive)
        );
      } catch (error) {
        this.logNonBlockingSamplesRegisterError(
          'Unable to persist express mode for guided tour',
          error
        );
      }
    },
    enableExpressModeForTour() {
      this.setExpressModeStateForTour(true);
    },
    disableExpressModeForTour() {
      this.setExpressModeStateForTour(false);
    },
    async showTourStandardSavePopup() {
      this.setSampleCodeInfoPopUp(['DEMO-SM-001']);
      this.setConfirmPopup(true);
      await this.$nextTick();
    },
    hideTourStandardSavePopup() {
      EventBus.$emit('samplesRegister:confirmPopupClosed');
      this.setConfirmPopup(false);
    },
    openTourVisibleFieldsPopup() {
      if (!this.expressMode) {
        this.enableExpressModeForTour();
      }
      this.showSelectablesFieldsPopup = true;
    },
    closeTourVisibleFieldsPopup() {
      this.showSelectablesFieldsPopup = false;
    },
    applyTourVisibleFieldsPreset() {
      const preset = this.normalizeExpressGridFieldsVisibility({
        ...this.expressGridFieldsVisibility,
        SubTipoMuestra: true,
        lote: true,
        Observaciones: true,
        automaticSamplingPoint: true,
        farmPoint: true,
        plotPoint: true,
      });

      this.expressGridFieldsVisibility = preset;
      this.saveExpressGridFieldsVisibility();
      EventBus.$emit(
        'samplesRegister:expressGridFieldsVisibility',
        this.expressGridFieldsVisibility
      );
    },
    async showTourFinalConfirmationPopup() {
      this.setInvoiceCodeInfoPopUp('ALB-DEMO-001');
      this.setConfirmDeliveryPopup(true);
      await this.$nextTick();
    },
    hideTourFinalConfirmationPopup() {
      this.setConfirmDeliveryPopup(false);
    },
    getSamplesRegisterAnalyticsContext() {
      // Contexto comun para eventos de registro de muestras:
      // cliente, pais e idioma del usuario autenticado.
      const authenticatedUser =
        this.$store?.state?.user?.authenticatedUser || {};
      const contact = this.$store?.state?.contact || {};
      const contactInfo =
        this.$store?.getters?.['contact/contactInfo'] || {};
      const language =
        authenticatedUser?.language_code ||
        authenticatedUser?.contacts?.[0]?.language;
      const companyCode =
        contact?.company ||
        authenticatedUser?.contacts?.[0]?.companies?.[0]?.code;
      const countryCode =
        contactInfo?.country ||
        (typeof companyCode === 'string' &&
        companyCode.trim().length >= 2
          ? companyCode.trim().substring(0, 2)
          : undefined);

      return {
        company_code: companyCode || undefined,
        country_code: countryCode || undefined,
        user_language: language || undefined,
      };
    },
    getSamplingTemplatesPopupShownCountThisSession() {
      if (typeof window === 'undefined') return 0;

      try {
        const rawCount = window.sessionStorage.getItem(
          SAMPLING_TEMPLATES_POPUP_SESSION_KEY
        );
        const parsedCount = Number.parseInt(rawCount, 10);
        return Number.isNaN(parsedCount) ? 0 : parsedCount;
      } catch (error) {
        return 0;
      }
    },
    hasReachedSamplingTemplatesPopupMaxThisSession() {
      return (
        this.getSamplingTemplatesPopupShownCountThisSession() >=
        SAMPLING_TEMPLATES_POPUP_MAX_PER_SESSION
      );
    },
    markSamplingTemplatesPopupAsShownThisSession() {
      if (typeof window === 'undefined') return;

      try {
        const nextCount =
          this.getSamplingTemplatesPopupShownCountThisSession() + 1;
        window.sessionStorage.setItem(
          SAMPLING_TEMPLATES_POPUP_SESSION_KEY,
          String(nextCount)
        );
      } catch (error) {
        this.logNonBlockingSamplesRegisterError(
          'Unable to persist sampling templates popup session counter',
          error
        );
      }
    },
    shouldHideSamplingTemplatesPopupForGuidedTour() {
      return !!(
        this.guidedTourStartTimeoutId ||
        isSamplesRegisterGuidedTourActiveOrPending()
      );
    },
    async openSamplingTemplatesAvailablePopupIfNeeded() {
      if (this.selectedIndex !== 0) return;
      if (this.shouldSkipSamplingTemplatesAvailablePopup()) {
        this.setConfirmTemplatesAvailablePopup(false);
        return;
      }
      if (this.shouldHideSamplingTemplatesPopupForGuidedTour()) {
        this.setConfirmTemplatesAvailablePopup(false);
        return;
      }

      if (this.hasReachedSamplingTemplatesPopupMaxThisSession()) {
        this.setConfirmTemplatesAvailablePopup(false);
        return;
      }

      try {
        const templates = await this.fetchTemplates({
          active: true,
        });

        const hasActiveTemplates =
          Array.isArray(templates) && templates.length > 0;

        if (this.shouldHideSamplingTemplatesPopupForGuidedTour()) {
          this.setConfirmTemplatesAvailablePopup(false);
          return;
        }

        this.setConfirmTemplatesAvailablePopup(hasActiveTemplates);
        if (hasActiveTemplates) {
          this.trackSamplesRegisterEvent(
            'sampling_templates_available_popup_shown',
            {
              screen_name: 'SamplesRegister',
              active_templates_count: templates.length,
            }
          );
          this.markSamplingTemplatesPopupAsShownThisSession();
        }
      } catch (error) {
        this.setConfirmTemplatesAvailablePopup(false);
      }
    },
    resolveInitialTabIndex() {
      const query = this.$f7router?.currentRoute?.query || {};
      const rawTab = query?.tab;
      const parsedTab = Number(rawTab);

      if (
        Number.isInteger(parsedTab) &&
        parsedTab >= 0 &&
        parsedTab <= 2
      ) {
        return parsedTab;
      }

      return 0;
    },
    getRouteQuery() {
      return (
        this.$f7route?.query ||
        this.$route?.query ||
        this.$f7router?.currentRoute?.query ||
        {}
      );
    },
    isTemplateLoadedRouteQuery(query = {}) {
      return String(query?.source || '').toLowerCase() === 'template';
    },
    shouldSkipSamplingTemplatesAvailablePopup() {
      const query = this.getRouteQuery();
      const hasInvoiceSamples =
        Array.isArray(this.invoiceSamples) &&
        this.invoiceSamples.length > 0;

      return (
        this.isTemplateLoadedRouteQuery(query) || hasInvoiceSamples
      );
    },
    isExpressModeRouteQuery(query = {}) {
      // Compatibilidad retroactiva:
      // el modo actual es "express", pero seguimos aceptando
      // query params antiguos ("expressMode" o mode=simple)
      // para no romper accesos guardados, enlaces de plantillas
      // o navegaciones anteriores al cambio de naming.
      const rawMode =
        query?.mode ||
        query?.registerMode ||
        query?.expressMode ||
        query?.expressMode;
      const normalizedMode = String(rawMode || '').toLowerCase();

      return ['simple', 'express', 'true', '1'].includes(
        normalizedMode
      );
    },
    resolveInitialExpressMode() {
      const routeQuery =
        this.$f7router?.currentRoute?.query ||
        this.$f7route?.query ||
        this.$route?.query ||
        {};

      if (this.isExpressModeRouteQuery(routeQuery)) {
        return true;
      }

      try {
        const persistedExpressMode = localStorage.getItem(
          'samplesRegisterExpressMode'
        );

        if (persistedExpressMode === null) {
          return false;
        }

        return JSON.parse(persistedExpressMode) === true;
      } catch (error) {
        this.logNonBlockingSamplesRegisterError(
          'Unable to restore persisted express mode state',
          error
        );
        return false;
      }
    },
    applyRequestedExpressModeFromRoute() {
      const query =
        this.$f7route?.query ||
        this.$route?.query ||
        this.$f7router?.currentRoute?.query ||
        {};

      if (!this.isExpressModeRouteQuery(query)) return;

      // Si la pagina ya esta en express, solo resincronizamos el
      // EventBus para que los componentes hijos lean el estado actual
      // aunque hayan montado despues de resolver la ruta.
      if (this.expressMode) {
        EventBus.$emit('samplesRegister:expressMode', true);
        return;
      }

      this.applyExpressModeToggle(true);
    },
    applyRequestedTabFromRoute() {
      const requestedTab = Number(
        this.$f7route?.query?.tab ?? this.$route?.query?.tab
      );

      if (![0, 1, 2].includes(requestedTab)) return;

      this.selectedIndex = requestedTab;
      this.$nextTick(() => {
        this.$refs.tabPanelRef?.instance?.option(
          'selectedIndex',
          requestedTab
        );
      });
    },
    enrichFormDataWithInvoiceContext(formData) {
      if (!formData) return formData;

      const firstBudget = this.getFirstSelectableOffer();

      if (firstBudget?.CodCliente) {
        formData.CodCliente = firstBudget.CodCliente;
      }

      formData.idAlbaran = this.idInvoice;
      formData.CodAlbaran = this.invoiceCodeInfoPopUp;

      return formData;
    },
    isSelectableOffer(offer) {
      const blockedStatuses = new Set(['2', '4']);
      return !blockedStatuses.has(String(offer?.CodEstado ?? ''));
    },
    getSelectableOffers() {
      return Array.isArray(this.presupuestos)
        ? this.presupuestos.filter((offer) =>
            this.isSelectableOffer(offer)
          )
        : [];
    },
    getFirstSelectableOffer() {
      const [firstOffer] = this.getSelectableOffers();
      return firstOffer || null;
    },
    emitGa4Event(eventName, eventParams = {}) {
      emitSamplesRegisterGa4Event(this, eventName, eventParams);
    },
    logNonBlockingSamplesRegisterError(context, error) {
      console.warn(`[SamplesRegister] ${context}`, error);
    },
    trackSamplesRegisterEvent(eventName, extraParams = {}) {
      this.emitGa4Event(eventName, extraParams);
    },
    trackExpressSampleRegisterAccess(source = 'unknown') {
      const now = Date.now();
      if (now - this.lastExpressAccessTrackedAt < 800) return;
      this.lastExpressAccessTrackedAt = now;

      // El usuario ha pulsado el cambio al modo express
      // desde el flujo de registro de muestras.
      // Parametros distintivos:
      // - screen_name: pantalla destino del modo express
      // - access_source: origen exacto del cambio (toggle)
      this.emitGa4Event('express_sample_register_access', {
        screen_name: 'ExpressSampleRegister',
        access_source: source,
      });
    },
    trackStandardSampleRegisterSuccess() {
      // Se ha registrado correctamente una muestra desde el formulario
      // estandar del paso 1, pero aun no implica que el albaran
      // completo haya sido confirmado en el paso 3.
      // Parametros distintivos:
      // - register_mode: standard
      // - samples_count: 1 porque este flujo registra una muestra por envio
      this.emitGa4Event('sample_register_success', {
        screen_name: 'SampleRegister',
        register_mode: 'standard',
        samples_count: 1,
      });
    },
    trackExpressSampleRegisterSuccess() {
      const rows = Array.isArray(this.lastFormData?.MuestrasExpress)
        ? this.lastFormData.MuestrasExpress
        : [];
      // Seguimos midiendo las columnas visibles del grid express
      // porque sustituyen al antiguo "expressGrid" en analitica
      // y nos permiten comparar uso antes y despues del renombrado.
      const selectedFieldsCount = Object.values(
        this.expressGridFieldsVisibility || {}
      ).filter((value) => value === true).length;

      // Se han registrado correctamente una o varias muestras desde
      // el modo express, pero aun no implica confirmacion final
      // del albaran en el paso 3.
      // Parametros distintivos:
      // - register_mode: express
      // - samples_count: numero de muestras registradas en bloque
      // - selected_optional_fields: cantidad de columnas opcionales visibles
      this.emitGa4Event('express_sample_register_success', {
        screen_name: 'ExpressSampleRegister',
        register_mode: 'express',
        samples_count: rows.length,
        selected_optional_fields: selectedFieldsCount,
      });
    },
    trackSamplesRegisterDeliveryConfirmed() {
      const acceptedOffers = Array.isArray(
        this.$store?.state?.Offers?.RespuestaAceptacion
      )
        ? this.$store.state.Offers.RespuestaAceptacion.filter(
            (item) => Number(item?.Respuesta) === 2
          ).length
        : 0;

      // Confirmacion final del proceso de registro en el paso 3.
      // Este es el evento que mejor representa que el usuario
      // ha completado realmente el alta del albaran.
      // Parametros distintivos:
      // - register_mode: ultimo modo con el que se registraron muestras
      // - samples_count: total de muestras del albaran en ese momento
      // - accepted_offers_count: presupuestos aceptados al confirmar
      // - has_external_agency: si usa agencia ajena
      // - has_order_number: si informa numero de pedido
      this.emitGa4Event('sample_register_delivery_confirmed', {
        register_mode:
          this.lastRegisteredMode ||
          (this.expressMode ? 'express' : 'standard'),
        samples_count: Array.isArray(this.invoiceSamples)
          ? this.invoiceSamples.length
          : 0,
        accepted_offers_count: acceptedOffers,
        has_external_agency: Boolean(
          this.lastFormData2?.checkAgenciaAjena
        ),
        has_order_number: Boolean(
          this.lastFormData2?.orderNumber?.toString().trim()
        ),
      });
    },
    isExpressValueEmpty(value) {
      return (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '')
      );
    },
    getExpressRowUi(row) {
      // Compatibilidad con filas nuevas (`ui`) y legacy (`_ui`).
      return row?.ui || row?._ui || {};
    },
    isExpressRowRegistered(row) {
      return Boolean(this.getExpressRowUi(row)?.isRegistered);
    },
    isExpressSelectedFieldApplicable(row, fieldKey) {
      const ui = this.getExpressRowUi(row);
      switch (fieldKey) {
        case 'cma':
          return Boolean(ui.checkCma);
        case 'Legislacion':
          return Boolean(ui.legislationVisible);
        case 'automaticSamplingPoint':
          return ui.showSamplingPoints !== false;
        case 'farmPoint':
        case 'plotPoint':
          return ui.showSamplingPoints !== false;
        case 'samplingPointCoordinate':
          return (
            ui.showSamplingPoints !== false &&
            row?.automaticSamplingPoint === true &&
            Array.isArray(ui.filteredLevelPoints) &&
            ui.filteredLevelPoints.length > 0
          );
        case 'lmr':
          return Boolean(ui.checkLmr);
        case 'trazaCultivo':
        case 'CultivoOrganico':
          return Boolean(ui.traceCultiveVisible);
        default:
          return true;
      }
    },
    isExpressSelectedFieldFilled(row, fieldKey) {
      const checkFields = [
        'cma',
        'automaticSamplingPoint',
        'lmr',
        'trazaCultivo',
        'CultivoOrganico',
      ];
      if (checkFields.includes(fieldKey)) {
        return typeof row?.[fieldKey] === 'boolean';
      }

      switch (fieldKey) {
        case 'farmPoint':
          if (row?.automaticSamplingPoint) {
            return !this.isExpressValueEmpty(row?.Parcelas);
          }
          return !this.isExpressValueEmpty(row?.FincaLiteral);
        case 'plotPoint':
          if (row?.automaticSamplingPoint) {
            return !this.isExpressValueEmpty(row?.Parcela);
          }
          return !this.isExpressValueEmpty(row?.ParcelaLiteral);
        case 'samplingPointCoordinate':
          return Number(row?.idNivelPunto) > 0;
        case 'Legislacion':
          return Number(row?.Legislacion) > 0;
        default:
          return !this.isExpressValueEmpty(row?.[fieldKey]);
      }
    },
    validateExpressSamplesBeforeSave() {
      const form = this.lastFormData || {};
      const rows = Array.isArray(form.MuestrasExpress)
        ? form.MuestrasExpress
        : [];

      const requiredHeaderFields = ['CodPresupuesto', 'SamplingDate'];
      const headerInvalid = requiredHeaderFields.some((field) =>
        this.isExpressValueEmpty(form[field])
      );
      if (headerInvalid || rows.length === 0) return false;

      const requiredRowFields = [
        'DescripcionMuestra',
        'FamiliaTM',
        'Descripcion',
        'Articulo',
      ];

      return rows.every((row) => {
        if (this.isExpressRowRegistered(row)) {
          return true;
        }

        const missingRequired = requiredRowFields.some((field) =>
          this.isExpressValueEmpty(row?.[field])
        );
        return !missingRequired;
      });
    },
    normalizeExpressGridFieldsVisibility(visibility) {
      const normalized = {
        ...visibility,
      };

      // Reglas heredadas del grid antiguo:
      // algunas columnas dependen de otras y deben activarse juntas
      // para que la configuracion del modo express siga siendo valida.
      if (normalized.farmPoint || normalized.plotPoint) {
        normalized.automaticSamplingPoint = true;
      }

      if (normalized.samplingPointCoordinate) {
        normalized.automaticSamplingPoint = true;
        normalized.farmPoint = true;
        normalized.plotPoint = true;
      }

      if (!normalized.automaticSamplingPoint) {
        normalized.farmPoint = false;
        normalized.plotPoint = false;
        normalized.samplingPointCoordinate = false;
      }

      if (!normalized.farmPoint || !normalized.plotPoint) {
        normalized.samplingPointCoordinate = false;
      }

      return normalized;
    },
    loadExpressGridFieldsVisibility() {
      try {
        // La preferencia se guarda ya con la clave "express", pero el
        // contenido conserva la misma estructura funcional del grid
        // anterior para no alterar comportamiento al usuario.
        const raw = localStorage.getItem(
          this.expressGridFieldsVisibilityStorageKey
        );
        if (!raw) {
          EventBus.$emit(
            'samplesRegister:expressGridFieldsVisibility',
            this.expressGridFieldsVisibility
          );
          return;
        }

        const parsed = JSON.parse(raw);
        this.expressGridFieldsVisibility =
          this.normalizeExpressGridFieldsVisibility({
            ...this.expressGridFieldsVisibility,
            ...(parsed || {}),
          });
      } catch (error) {
        this.expressGridFieldsVisibility =
          this.normalizeExpressGridFieldsVisibility(
            this.expressGridFieldsVisibility
          );
      }

      EventBus.$emit(
        'samplesRegister:expressGridFieldsVisibility',
        this.expressGridFieldsVisibility
      );
    },
    saveExpressGridFieldsVisibility() {
      try {
        localStorage.setItem(
          this.expressGridFieldsVisibilityStorageKey,
          JSON.stringify(this.expressGridFieldsVisibility)
        );
      } catch (error) {
        this.logNonBlockingSamplesRegisterError(
          'Unable to persist express grid fields visibility',
          error
        );
      }
    },
    onExpressModeToggle(active) {
      if (active === this.expressMode) return;

      if (this.shouldWarnBeforeModeSwitch()) {
        this.pendingExpressMode = active;
        this.showModeSwitchWarningPopup = true;
        return;
      }

      this.applyExpressModeToggle(active);
    },
    applyExpressModeToggle(active) {
      this.expressMode = active;
      EventBus.$emit('samplesRegister:expressMode', active);
      try {
        // Persistimos el nuevo nombre de storage para alinear la UI
        // con "express"; el fallback de lectura por query antigua se
        // resuelve en isExpressModeRouteQuery cuando aplica.
        localStorage.setItem(
          'samplesRegisterExpressMode',
          JSON.stringify(active)
        );
      } catch (error) {
        this.logNonBlockingSamplesRegisterError(
          'Unable to persist express mode toggle state',
          error
        );
      }
      if (active && this.selectedIndex === 0) {
        this.trackExpressSampleRegisterAccess('toggle');
      }
    },
    shouldWarnBeforeModeSwitch() {
      return this.expressMode
        ? this.hasUnsavedExpressSample()
        : this.hasUnsavedStandardSample();
    },
    cancelExpressModeSwitch() {
      this.showModeSwitchWarningPopup = false;
      this.pendingExpressMode = null;
    },
    confirmExpressModeSwitch() {
      const nextMode = this.pendingExpressMode;

      this.showModeSwitchWarningPopup = false;
      this.pendingExpressMode = null;

      if (this.expressMode) {
        this.$refs.expressSampleRegister?.resetForModeSwitch?.();
      } else {
        this.$refs.standardSampleRegister?.resetForModeSwitch?.();
      }

      this.lastFormData = null;
      this.applyExpressModeToggle(nextMode);
    },
    onEditBubbleClick() {
      if (!this.expressMode) return;
      this.showSelectablesFieldsPopup = true;
    },
    openTemplatesFromHeader() {
      this.emitGa4Event('sampling_templates_list_open', {
        screen_name: 'TemplatesListPage',
        entry_point: 'samples_register_header_templates_button',
      });
      this.$f7router.navigate(
        {
          name: 'TemplatesListPage',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    onApplyExpressFieldsVisibility(visibility) {
      this.expressGridFieldsVisibility =
        this.normalizeExpressGridFieldsVisibility(visibility);
      this.saveExpressGridFieldsVisibility();
      EventBus.$emit(
        'samplesRegister:expressGridFieldsVisibility',
        this.expressGridFieldsVisibility
      );
    },
    toggleWithAnimationOptions() {
      this.withAnimationOptionsVisible =
        !this.withAnimationOptionsVisible;
    },
    async formatOffers() {
      const offers = this.getSelectableOffers().map((offer) => {
        const statusTranslated =
          offer.CodEstado === '1'
            ? this.$t(this.$helpers.getStatusTextKey(offer.Estado))
            : '';

        return {
          ...offer,
          CodOfferTitle: `${offer.CodPresupuesto} - ${offer.Titulo}${
            offer.CodEstado === '1' ? ` (${statusTranslated})` : ''
          }`,
        };
      });

      this.CustomStore = offers;
      if (
        this.offerSelected &&
        !offers.some(
          (offer) =>
            String(offer?.CodPresupuesto || '') ===
            String(this.offerSelected || '')
        )
      ) {
        this.setOfferSelected('');
      }
      return this.CustomStore;
    },
    isSaveSampleMissingFieldsError(error) {
      return (
        error?.message === 'missing_express_fields' ||
        (!error?.response && !error?.message)
      );
    },
    buildRegisterSampleApiPayload(formData, sampleOverride = null) {
      if (!formData) return null;

      const sampleData = sampleOverride
        ? { ...formData, ...sampleOverride }
        : formData;
      const today = new Date();

      return {
        CodCliente: sampleData.CodCliente,
        idWMuestra: 0,
        CodMuestra: null,
        DescripcionMuestra: sampleData.DescripcionMuestra,
        idAlbaran: sampleData.idAlbaran,
        CodAlbaran: sampleData.CodAlbaran,
        CodPresupuesto: sampleData.CodPresupuesto,
        CodLinea: sampleData.CodLinea,
        CodArticulo: sampleData.Articulo,
        idFamilia: sampleData.FamiliaTM,
        idSubFamiliaTM: sampleData.idSubFamiliaTM,
        idTipoMuestra:
          sampleData.idTipoMuestra ??
          sampleData.Descripcion?.idTipoMuestra,
        idSubTipoMuestra: sampleData.SubTipoMuestra,
        LoteCodigo: sampleData.lote,
        Pedido: '',
        idEstado: 101,
        Activo: true,
        idFinca: sampleData.Parcelas,
        FincaLiteral: sampleData.FincaLiteral,
        idParcela: sampleData.Parcela,
        ParcelaLiteral: sampleData.ParcelaLiteral,
        idNivelPunto: sampleData.idNivelPunto || 0,
        CultivoOrganico: sampleData.CultivoOrganico,
        LMR: sampleData.lmr,
        CodPais: '',
        CodPais2: '',
        CodPais3: '',
        CodPais4: '',
        CodPais5: '',
        CodPais6: '',
        CodPais7: '',
        CodPais8: '',
        CodPais9: '',
        CodPais10: '',
        Traza: sampleData.trazaCultivo,
        ResumenLMR: false,
        CMA: sampleData.cma,
        idLegislacion: sampleData.Legislacion,
        idMuestreador: 0,
        MuestreadorLiteral: sampleData.Sampler,
        PrecioAT: sampleData.PrecioAT,
        ObservacionesMuestra: sampleData.Observaciones,
        UsuarioAlta: 0,
        FechaMuestreo: sampleData.SamplingDate,
        FechaAlta: this.$helpers.getDateFormatedForBackEnd(today),
        FechaModificacion: null,
        ArchivoImgRutaLocal: '',
        ArchivoImgNombre: '',
        idAreaServicio: 0,
        PedidoCliente: '',
        idOrigen: 0,
        idPNTMuestreo: 0,
        CloroResidualLibre: sampleData.cloroResidual,
      };
    },
    rowHasMeaningfulData(row) {
      if (!row) return false;

      const fieldsToCheck = [
        'DescripcionMuestra',
        'FamiliaTM',
        'Descripcion',
        'Articulo',
        'SubTipoMuestra',
        'lote',
        'Observaciones',
        'Parcelas',
        'FincaLiteral',
        'Parcela',
        'ParcelaLiteral',
        'idNivelPunto',
        'Legislacion',
        'cloroResidual',
      ];

      return (
        fieldsToCheck.some((field) => {
          const value = row[field];
          return !(
            value === null ||
            value === undefined ||
            value === ''
          );
        }) ||
        row.cma === true ||
        row.lmr === true ||
        row.trazaCultivo === true ||
        row.CultivoOrganico === true
      );
    },
    hasUnsavedStandardSample() {
      if (!this.lastFormData || this.lastFormData.isExpressMode) {
        return false;
      }

      return this.rowHasMeaningfulData(this.lastFormData);
    },
    hasUnsavedExpressSample() {
      const rows = this.lastFormData?.MuestrasExpress || [];
      const hasDraftRows = rows.some(
        (row) =>
          !this.isExpressRowRegistered(row) &&
          this.rowHasMeaningfulData(row)
      );
      const hasRegisteredRowEdition = Boolean(
        this.$refs.expressSampleRegister?.hasActiveRegisteredRowEdit?.()
      );

      return hasDraftRows || hasRegisteredRowEdition;
    },
    shouldWarnBeforeContinue() {
      if (!Array.isArray(this.invoiceSamples)) return false;
      if (this.invoiceSamples.length === 0) return false;

      return this.expressMode
        ? this.hasUnsavedExpressSample()
        : this.hasUnsavedStandardSample();
    },
    hideUnsavedSampleWarningPopup() {
      this.showUnsavedSampleWarningPopup = false;
      this.pendingUnsavedAction = null;
    },
    async saveSampleFromWarningPopup() {
      const pendingAction = this.pendingUnsavedAction;
      this.showUnsavedSampleWarningPopup = false;
      this.pendingUnsavedAction = null;

      if (
        this.expressMode &&
        this.$refs.expressSampleRegister?.hasActiveRegisteredRowEdit?.()
      ) {
        const saved =
          await this.$refs.expressSampleRegister?.saveRegisteredRowEdit?.();
        if (!saved) return;
      } else {
        await this.SaveSample();
      }

      await this.performPendingUnsavedAction(pendingAction);
    },
    continueWithoutSavingSample() {
      const pendingAction = this.pendingUnsavedAction;
      this.showUnsavedSampleWarningPopup = false;
      this.pendingUnsavedAction = null;

      if (this.expressMode) {
        this.$refs.expressSampleRegister?.discardActiveRegisteredRowEdit?.();
      }

      this.performPendingUnsavedAction(pendingAction);
    },
    async performPendingUnsavedAction(action) {
      switch (action) {
        case 'template':
          await this.$refs.expressSampleRegister?.goToTemplateCreatePage?.();
          break;
        case 'confirm':
        default:
          this.suppressNextTabGuard = true;
          this.$refs.tabPanelRef.instance.option('selectedIndex', 1);
      }
    },
    async onSimpleSaveTemplateRequest() {
      await this.$refs.expressSampleRegister?.commitGridEdits?.();
      this.$refs.expressSampleRegister?.emitMultiForm?.();

      if (this.shouldWarnBeforeContinue()) {
        this.pendingUnsavedAction = 'template';
        this.showUnsavedSampleWarningPopup = true;
        return;
      }

      await this.$refs.expressSampleRegister?.goToTemplateCreatePage?.();
    },
    getSaveSampleDebugPayloads() {
      if (!this.lastFormData) return [];

      if (this.lastFormData.isExpressMode) {
        return (this.lastFormData.MuestrasExpress || []).map(
          (sample, index) => ({
            index,
            payload: this.buildRegisterSampleApiPayload(
              this.lastFormData,
              sample
            ),
          })
        );
      }

      return [
        {
          index: 0,
          payload: this.buildRegisterSampleApiPayload(
            this.lastFormData
          ),
        },
      ];
    },
    getSaveSampleErrorDetails(error) {
      return {
        name: error?.name || null,
        message: error?.message || null,
        status: error?.response?.status || error?.status || null,
        statusText:
          error?.response?.statusText || error?.statusText || null,
        responseData: error?.response?.data || null,
        responseError:
          error?.response?.data?.error || error?.error || null,
        responseMessage: error?.response?.data?.message || null,
        rawResponse: error?.response || null,
        stack: error?.stack || null,
      };
    },
    stringifyConsoleValue(value) {
      if (value === null || value === undefined) {
        return '-';
      }

      if (typeof value === 'string') {
        return value.trim() || '-';
      }

      if (typeof value === 'object') {
        try {
          return JSON.stringify(value, null, 2);
        } catch (error) {
          return String(value);
        }
      }

      return String(value);
    },
    buildSaveSampleReadableLog(summary, debugPayloads, errorDetails) {
      const payloadBlocks = debugPayloads.length
        ? debugPayloads
            .map(
              ({ index, payload }) =>
                `Payload ${index + 1}:\n${this.stringifyConsoleValue(
                  payload
                )}`
            )
            .join('\n\n')
        : 'Payload: -';

      return [
        '[SamplesRegister][SaveSample] Error registering sample',
        `DateTime: ${summary.requestDateTimeIso}`,
        `Mode: ${summary.registerMode}`,
        `CodCliente: ${summary.companyCode || '-'}`,
        `Address: ${summary.addressCode || '-'}`,
        `IdAlbaran: ${summary.invoiceId || '-'}`,
        `CodAlbaran: ${summary.invoiceCode || '-'}`,
        `CodPresupuesto: ${summary.budgetCode || '-'}`,
        `DescripcionMuestra: ${summary.sampleDescription || '-'}`,
        `SamplesToSend: ${summary.samplesToSend}`,
        `HTTP Status: ${summary.httpStatus || '-'}`,
        `Status Text: ${errorDetails.statusText || '-'}`,
        `Backend Message: ${
          errorDetails.responseError ||
          errorDetails.responseMessage ||
          errorDetails.message ||
          '-'
        }`,
        `Response Data: ${this.stringifyConsoleValue(
          errorDetails.responseData
        )}`,
        payloadBlocks,
      ].join('\n');
    },
    logSaveSampleErrorDiagnostics(error) {
      const debugPayloads = this.getSaveSampleDebugPayloads();
      const errorDetails = this.getSaveSampleErrorDetails(error);
      const companyCode =
        this.$store?.state?.contact?.company || null;
      const addressCode =
        this.$store?.state?.contact?.address || null;
      const requestedAt = new Date();
      const summary = {
        companyCode,
        addressCode,
        requestDate:
          this.$helpers.getDateFormatedForBackEnd(requestedAt),
        requestDateTimeIso: requestedAt.toISOString(),
        registerMode: this.lastFormData?.isExpressMode
          ? 'express'
          : 'standard',
        invoiceId: this.idInvoice || null,
        invoiceCode: this.invoiceCodeInfoPopUp || null,
        budgetCode: this.lastFormData?.CodPresupuesto || null,
        sampleDescription:
          this.lastFormData?.DescripcionMuestra || null,
        samplesToSend: debugPayloads.length,
        backendMessage:
          errorDetails.responseError ||
          errorDetails.responseMessage ||
          errorDetails.message,
        httpStatus: errorDetails.status,
      };
      const readableLog = this.buildSaveSampleReadableLog(
        summary,
        debugPayloads,
        errorDetails
      );

      console.error(readableLog);

      if (errorDetails.stack) {
        console.error(`Stack:\n${errorDetails.stack}`);
      }
    },
    async SaveSample() {
      try {
        const isExpressModeActive = this.expressMode === true;

        if (isExpressModeActive) {
          await this.$refs.expressSampleRegister?.commitGridEdits?.();
          this.$refs.expressSampleRegister?.emitMultiForm?.();
          if (
            this.$refs.expressSampleRegister?.hasActiveRegisteredRowEdit?.()
          ) {
            const saved =
              await this.$refs.expressSampleRegister?.saveRegisteredRowEdit?.();
            if (!saved) {
              throw new Error('missing_express_fields');
            }
            return;
          }
        }
        if (isExpressModeActive) {
          if (!this.validateExpressSamplesBeforeSave()) {
            throw new Error('missing_express_fields');
          }
        } else {
          const requiredFields = [
            'CodPresupuesto',
            'SamplingDate',
            'FamiliaTM',
            'Descripcion',
            'Articulo',
            'DescripcionMuestra',
          ];
          const missingFields = requiredFields.filter(
            (field) =>
              this.lastFormData[field] === null ||
              this.lastFormData[field] === undefined
          );
          if (missingFields.length > 0) {
            throw new Error();
          }
        }
        this.$f7.preloader.show();
        if (isExpressModeActive) {
          const newCodes =
            (await this.$refs.expressSampleRegister?.registerPendingRows()) ||
            [];
          const fallbackCodes =
            this.$refs.expressSampleRegister?.getRegisteredCodes?.() ||
            [];
          await this.$refs.expressSampleRegister?.showExpressConfirmPopup?.(
            newCodes.length ? newCodes : fallbackCodes
          );
        } else {
          await this.registerInvoiceSamples(this.lastFormData);
        }
        if (!isExpressModeActive) {
          await this.fetchInvoiceSamples(this.idInvoice);
        }
        if (isExpressModeActive) {
          this.lastRegisteredMode = 'express';
          this.trackExpressSampleRegisterSuccess();
        } else {
          this.lastRegisteredMode = 'standard';
          this.trackStandardSampleRegisterSuccess();
        }
        if (!isExpressModeActive) {
          this.setConfirmPopup(true);
        }
      } catch (error) {
        const isMissingFieldsError =
          this.isSaveSampleMissingFieldsError(error);

        if (!isMissingFieldsError) {
          this.logSaveSampleErrorDiagnostics(error);
        }

        let errorMessage = this.$t(
          'samplesRegister.missingFieldsError'
        );
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          errorMessage = this.$t('internalServerError');
        } else if (!isMissingFieldsError && error.message) {
          errorMessage = this.$t('internalServerError');
        }
        this.setErrorPopup({ visible: true, message: errorMessage });

        // this.$notifyDX(
        //   {
        //     message: errorMessage,
        //     width: 550,
        //   },
        //   'error',
        //   NOTIFY_TIME_LONG
        // );
      } finally {
        this.$f7.preloader.hide();
        // this.lastFormData.Observaciones = null;
        // this.lastFormData.DescripcionMuestra = null;
        // if (this.lastFormData) {
        //   this.lastFormData.Observaciones = null;
        //   this.lastFormData.DescripcionMuestra = null;
        // }
      }
    },
    async AceptarPresupuesto(form) {
      if (
        form.CodPresupuesto?.startsWith('QCF') ||
        form.CodPresupuesto?.startsWith('QCA')
      ) {
        this.$notifyDX(
          {
            message: this.$t(
              'No se pueden aceptar presupuestos de tipo QSP, QCA o QCF'
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } else {
        const pendingOffer = this.presupuestos.filter(
          (codOffer) =>
            codOffer.CodPresupuesto === form.CodPresupuesto
        );
        try {
          await this.aceptarPresupuesto({
            CodPresupuesto: pendingOffer[0].CodPresupuesto,
            Email: null,
            Activado: null,
            IP: null,
            Navegador: null,
            Respuesta: null,
          });
        } catch (error) {
          this.$notifyDX(
            {
              message: this.$t(
                this.$helpers.getFilteredErrorMessage(
                  JSON.parse(error.message).error
                )
              ),
              width: 550,
            },
            'error',
            NOTIFY_TIME_LONG
          );
        }
      }
    },
    async receiveMessage(FormData) {
      if (!FormData) return this.lastFormData;

      // Filtramos por isExpressMode porque ahora conviven dos payloads:
      // el formulario estandar y el express comparten receptor y no
      // deben pisarse entre si cuando el usuario cambia de modo.
      const formIsExpressMode = FormData.isExpressMode === true;
      if (formIsExpressMode !== this.expressMode) {
        return this.lastFormData;
      }

      this.lastFormData =
        this.enrichFormDataWithInvoiceContext(FormData);
      return this.lastFormData;
    },
    async receiveMessageV2(FormData) {
      this.lastFormData2 =
        this.enrichFormDataWithInvoiceContext(FormData);
      return this.lastFormData2;
    },
    async ConfirmInvoice() {
      if (this.invoiceSamples.length > 0) {
        try {
          const isColombiaClient = String(
            this.lastFormData2?.CodCliente || this.company || ''
          )
            .trim()
            .toUpperCase()
            .startsWith('CO');

          if (
            isColombiaClient &&
            this.lastFormData2
              ?.AceptacionResponsabilidadesColombia !== true
          ) {
            this.$notifyDX(
              {
                message: this.$t(
                  'samplesRegister.colombiaResponsibilityRequired'
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
            return;
          }

          const requiredFields = ['shippingDate'];
          // Si ha marcado envío independiente
          if (this.lastFormData2.checkAgenciaAjena) {
            requiredFields.push('AgenciaLiteral');
            this.lastFormData2.Agencia = 8; // ID de agencia de cliente sin coste de envío
          } else {
            requiredFields.push('Agencia');
          }
          const missingFields = requiredFields.filter(
            (field) =>
              !this.lastFormData2[field] ||
              this.lastFormData2[field].toString().trim() === ''
          );
          if (missingFields.length > 0) {
            throw new Error();
          }
          this.$f7.preloader.show();
          // Si ha indicado un número de pedido/orden de compra, se asigna a todas las muestras para SIL
          const normalizedOrderNumber =
            this.lastFormData2?.orderNumber?.toString().trim() || '';
          console.log(
            '[SamplesRegister] ConfirmInvoice orderNumber check',
            {
              normalizedOrderNumber,
              invoiceSamples: this.invoiceSamples.map((sample) => ({
                CodMuestra: sample.CodMuestra,
                CodArticulo: sample.CodArticulo,
                Lote: sample.Lote,
                LoteCodigo: sample.LoteCodigo,
                Pedido: sample.Pedido,
              })),
            }
          );
          if (normalizedOrderNumber) {
            await Promise.all(
              this.invoiceSamples.map((sample) => {
                const data = {
                  ...sample,
                  checkNumPedido: true,
                  orderNumber: normalizedOrderNumber,
                };
                return this.updateSample(data);
              })
            );
          }
          const uniqueSamplesByBudget = this.invoiceSamples.filter(
            (sample, index, samples) => {
              const budgetCode = sample?.CodPresupuesto;
              if (!budgetCode) return false;
              return (
                samples.findIndex(
                  (candidate) =>
                    candidate?.CodPresupuesto === budgetCode
                ) === index
              );
            }
          );
          for (let i = 0; i < uniqueSamplesByBudget.length; i += 1) {
            await this.AceptarPresupuesto(uniqueSamplesByBudget[i]);
          }
          await this.updateInvoice({
            ...this.lastFormData2,
            FechaAlta:
              this.invoiceDetails?.FechaAltaDate ||
              this.invoiceDetails?.FechaAlta ||
              null,
            updateSource: 'registration_step_3',
          });
          this.trackSamplesRegisterDeliveryConfirmed();
          this.setConfirmDeliveryPopup(true);
        } catch (error) {
          this.$notifyDX(
            {
              message: this.$t('samplesRegister.missingFieldsError'),
              width: 550,
            },
            'error',
            NOTIFY_TIME_LONG
          );
        } finally {
          this.$f7.preloader.hide();
        }
      } else {
        this.$notifyDX(
          {
            message: this.$t(
              'samplesRegister.requiresOneSampleRegistered'
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    getCurrentInvoiceId() {
      if (Array.isArray(this.idInvoice)) {
        return this.idInvoice[0] || null;
      }

      return this.idInvoice || null;
    },
    async deleteCurrentInvoice() {
      const currentInvoiceId = this.getCurrentInvoiceId();
      if (!currentInvoiceId) return;

      await this.deleteInvoice({
        idInvoice: currentInvoiceId,
        deleteSource: 'registration_cancel',
      });
      this.setInvoiceSamples([]);
      this.setIdInvoice(null);
      this.setInvoiceCodeInfoPopUp(null);
    },
    async goBack() {
      try {
        await this.deleteCurrentInvoice();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7router.navigate(
          {
            name: 'SamplesList',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      }
    },
    goToSamplesList() {
      this.$f7router.navigate(
        {
          name: 'SamplesList',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },

    async syncExpressRowsFromInvoiceSamples() {
      if (!this.expressMode) return;

      // await this.fetchInvoiceSamples(this.idInvoice);
      await this.$nextTick();

      await this.$refs.expressSampleRegister?.syncRowsFromInvoiceSamples?.();
    },

    async onTabChange(e) {
      const nextIndex = e.component.option('selectedIndex');

      if (this.suppressNextTabGuard) {
        this.suppressNextTabGuard = false;
        this.selectedIndex = nextIndex;

        if (this.selectedIndex === 0) {
          await this.syncSimpleRowsFromInvoiceSamples();
        }
        return;
      }

      this.selectedIndex = nextIndex;

      // selectedIndex 0 = Alta de muestras
      // selectedIndex 1 = Confirmación
      // selectedIndex 2 = Envío
      if (this.selectedIndex === 0) {
        await this.syncExpressRowsFromInvoiceSamples();
      }
    },
    async GoConfirmar() {
      if (this.expressMode) {
        await this.$refs.expressSampleRegister?.commitGridEdits?.();
        this.$refs.expressSampleRegister?.emitMultiForm?.();
      }

      if (this.shouldWarnBeforeContinue()) {
        this.pendingUnsavedAction = 'confirm';
        this.showUnsavedSampleWarningPopup = true;
        return;
      }

      this.suppressNextTabGuard = true;
      this.$refs.tabPanelRef.instance.option('selectedIndex', 1);
    },
    async addSample() {
      this.$refs.tabPanelRef.instance.option('selectedIndex', 0);

      await this.syncExpressRowsFromInvoiceSamples();

      await this.$nextTick();

      if (this.expressMode) {
        this.$refs.expressSampleRegister?.addRow?.();
      }
    },
    async ForwardTo(tabId) {
      this.$refs.tabPanelRef.instance.option('selectedIndex', tabId);
      this.selectedIndex = tabId;
    },
    async showContinue(showBottom) {
      this.showContinueBottom = showBottom;
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', [
      'fetchPresupuestos',
      'aceptarPresupuesto',
    ]),
    ...mapActions('samplesRegisterModule', [
      'fetchAgencies',
      'setOfferSelected',
      'setConfirmPopup',
      'setConfirmExpressSamplePopUp',
      'setConfirmDeliveryPopup',
      'setConfirmTemplatesAvailablePopup',
      'registerInvoiceSamples',
      'fetchInvoiceSamples',
      'updateInvoice',
      'updateSample',
      'setInvoiceSamples',
      'setIdInvoice',
      'deleteInvoice',
      'setErrorPopup',
      'setSampleCodeInfoPopUp',
      'setInvoiceCodeInfoPopUp',
    ]),
    ...mapActions('samplingTemplatesModule', ['fetchTemplates']),
  },
};
</script>
<style scoped lang="scss">
@import './SamplesRegister.styles.scss';
</style>

<style scoped>
.warning-popup-icon {
  width: 70px;
  height: 70px;
  background-image: url('@/static/icons/black_warning.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.samples-register-unsaved-warning-popup .popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.samples-register-unsaved-warning-popup .popup-content {
  padding: 15px 25px 25px 25px;
  padding-top: 0;
  text-align: center;
}

.samples-register-unsaved-warning-popup .popup-title {
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 15px;
}

.samples-register-unsaved-warning-popup .btn-accept {
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  padding: 16px;
  padding-top: 2px;
}

.samples-register-unsaved-warning-popup .btn-secondary {
  background-color: white !important;
  color: #00346a !important;
  border: 1px solid #00346a !important;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  width: auto;
  padding: 16px;
  padding-top: 0;
}
.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .dx-popup-title,
.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .dx-toolbar,
.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .dx-toolbar-items-container {
  background: #ffffff !important;
  border: none !important;
  border-bottom: none !important;
}

.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .dx-popup-title {
  padding: 6px 20px !important;
  min-height: 110px !important;
  color: #323232 !important;
}

.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .custom-popup-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dx-overlay-wrapper.samples-register-unsaved-warning-popup
  .warning-popup-icon {
  width: 70px;
  height: 70px;
  margin-top: 10px;
  background-image: url('@/static/icons/black_warning.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.samples-register-footer-actions {
  width: 100%;
  align-items: center;
}

.samples-register-actions-left {
  display: flex;
  align-items: center;
}

.samples-register-actions-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
}

.samples-register-cancel-button {
  width: 230px !important;
  min-width: 230px !important;
  max-width: none !important;
  padding: 0 16px !important;
  white-space: nowrap !important;
}

.samples-register-actions-left {
  display: flex;
  align-items: center;
}

.samples-register-footer-actions {
  width: 100%;
  align-items: center;
}

.samples-register-actions-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
}
</style>
